import { getKeycloakService } from './services/keycloak';

const makeHost = () => {
    const base = `${window.location.protocol}//${window.location.hostname}`;

    if( process.env.REACT_APP_HTTPS_API_PORT || process.env.REACT_APP_API_PORT ) {
        return `${base}:${window.location.protocol.includes('https:') ? process.env.REACT_APP_HTTPS_API_PORT : process.env.REACT_APP_API_PORT}`
    }

    return base;
};

const host = makeHost();

const headers = (orgId) => {
    const iAmToken = localStorage.getItem('iAmToken');
    const authToken = localStorage.getItem('authToken');
    
    // Check for Keycloak token
    const keycloakService = getKeycloakService();
    const keycloakToken = keycloakService?.getToken();

    const headers = {
        "Content-Type": "application/json",
        "X-Org-ID": orgId ? orgId : localStorage.getItem("orgId")
    };

    // Use Keycloak token if available, otherwise fall back to legacy tokens
    if (keycloakToken) {
        headers["Authorization"] = `Bearer ${keycloakToken}`;
        console.log('Using Keycloak token for request');
    } else {
        if( authToken ) {
            headers["X-Auth-Token"] = authToken;
        }

        if( iAmToken ) {
            headers["X-I-Am-Token"] = iAmToken;
        }
    }

    return headers;
};

export const get = (url, orgId) => {
    const options = {
        headers: headers(orgId)
    };

    return fetch(`${host}${url}`, options).then( responseHandler );
};

export const post = (url, body) => {
    const options = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: headers()
    };

    return fetch(`${host}${url}`, options).then( responseHandler );
};

export const patch = (url, body) => {
    const options = {
        method: 'PATCH',
        body: JSON.stringify(body),
        headers: headers()
    };

    return fetch(`${host}${url}`, options).then( responseHandler );
};

export const remove = (url, body) => {
    const options = {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: headers()
    };

    return fetch(`${host}${url}`, options).then( responseHandler );
};

const responseHandler = function (response) {
    return response.text().then((text) => {
        let data;

        try {
            data = text && JSON.parse(text);
        } catch (e) {
            // If response is not JSON, return error with status text
            if (!response.ok) {
                let err = new Error(response.statusText || 'Request failed');
                err.code = response.status;
                return Promise.reject(err);
            }
            return Promise.reject(e);
        }

        if (!response.ok) {
            let err = new Error(response.statusText || 'Request failed');
            err.code = response.status;

            // Try to extract error message from JSON API format
            if (data && data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
                const error = data.errors[0];
                err.message = error.title || error.message || err.message;
            } else if (data && data.message) {
                // Fallback to message field
                err.message = data.message;
            } else if (data && typeof data === 'string') {
                // If data is a string, use it as error message
                err.message = data;
            }

            return Promise.reject(err);
        }

        return data;
    });
};
